import {
  Drawer,
  DrawerContent,
  DrawerHeader
} from '@library/components/navigation';
import { SecondaryButton } from '@library/components/buttons';

export const QuickFiltersDrawer = ({
  drawerOpen,
  handleCancelDrawer,
  handleApplyFilterSet
}: {
  drawerOpen: boolean;
  handleCancelDrawer: () => void;
  handleApplyFilterSet: (filterSet: string) => void;
}) => {
  return (
    <Drawer
      direction="right"
      isOpen={drawerOpen}
      onCloseDrawer={handleCancelDrawer}
      size="large"
    >
      <DrawerHeader
        subtitle="Trading Dashboard"
        onClickClose={handleCancelDrawer}
      >
        Quick Filters
      </DrawerHeader>
      <DrawerContent>
        <div className="flex w-full flex-col gap-2">
          <div className="flex flex-row items-center">
            <span>Show all Pre-Game Demons &amp; Goblins</span>
            <div className="grow" />
            <SecondaryButton
              aria-label="Show pre-game D&G"
              data-testid="pre-game-dg"
              title="PreGameDG"
              handleOnClick={() => handleApplyFilterSet('PRE_GAME_DG')}
            >
              Apply
            </SecondaryButton>
          </div>
          <div className="flex flex-row items-center">
            <span>Show all Points projections with status Removed</span>
            <div className="grow" />
            <SecondaryButton
              aria-label="Show Points + Removed"
              data-testid="points-removed"
              title="PointsRemoved"
              handleOnClick={() => handleApplyFilterSet('REMOVED_POINTS')}
            >
              Apply
            </SecondaryButton>
          </div>
          <div className="flex flex-row items-center">
            <span>Show today&apos;s games</span>
            <div className="grow" />
            <SecondaryButton
              aria-label="Show Today's Games"
              data-testid="todays-games"
              title="TodaysGames"
              handleOnClick={() => handleApplyFilterSet('TODAYS_GAMES')}
            >
              Apply
            </SecondaryButton>
          </div>
          {/* <div className="flex h-10 flex-row items-center">
            <span className="text-soFresh-120">
              Activate odds heatmap (coming soon)
            </span>
            <div className="grow" />
            <Checkbox
              id="showOddsHeatmapCheckbox"
              onCheckboxChange={() => {}}
              labelClassName="w-fit"
              disabled
            />
          </div> */}
        </div>
      </DrawerContent>
    </Drawer>
  );
};
